<template>
  <v-card-text>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-form>
      <v-layout wrap justify-start pt-2>
        <v-flex xs12 sm12 md12 lg12 class="subheading">
          <span style="color:black">Title</span>
          <v-text-field class="pt-2 text-des" outlined v-model="title" dense hide-details>
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 pt-3 class="subheading">
          <span style="color:black">Description</span>
          <v-textarea outlined v-model="description" dense hide-details class="pt-2 text-des">
          </v-textarea>
        </v-flex>
        <v-flex class="subheading" pt-2 xs12 align-self-center text-left>
          <span style="color:black"> Upload Images</span>
          <v-layout wrap justify-center pa-5 style="border: solid 1px">
            <v-flex xs12 text-left class="pt-2 text-des">
              <v-layout wrap justify-start>
                <v-flex xs12 sm6 md4 lg4 pa-5 v-for="(items, index) in displayImage" :key="index">
                  <v-img :src="items" fill-height height="100%" width="100%">
                    <v-layout wrap>
                      <v-flex text-right pa-0>
                        <v-avatar color="#FF3434" size="15">
                          <v-icon color="#FFF" small @click="removeImage(index)">
                            mdi-close
                          </v-icon>
                        </v-avatar>
                      </v-flex>
                    </v-layout>
                  </v-img>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-end>
                <v-flex xs12 text-right>
                  <v-btn color="blue-grey" dark small @click="$refs.uploadDoc.click()"
                    class="itemform"><span> UPLOAD IMAGES </span>
                    <v-icon right dark> mdi-cloud-upload </v-icon></v-btn>
                </v-flex>
                <input v-show="false" id="file1" ref="uploadDoc" multiple type="file"
                  accept=".svg, .png, .jpg, .jpeg" @change="uploadDoc" />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-form>
    <v-card-actions class="py-4 justify-end headline lighten-2">
      <v-btn tile :color="appColor" light :ripple="false" depressed class="itemValue"
        @click="itemadd()"><span style="color:white;">Submit</span></v-btn>
    </v-card-actions>
  </v-card-text>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      title: "",
      description: "",
      appLoading: false,
      ServerError: false,
      docs: [],
      displayImage: [],
      fileArray: [],
      docs1: [],
      appColor: "#427D2D",
    };
  },
  methods: {
    clearForm() {
      this.description = "";
      this.displayImage = [];
      this.title = "";
      this.docs = [];
      this.fileArray = [];
    },
    removeImage(index) {
      this.displayImage.splice(index, 1);
      this.docs.splice(index, 1);
      this.fileArray.splice(index, 1);
    },
    uploadDoc(event) {
      this.docs1 = event.target.files || event.dataTransfer.files;
      if (this.docs.length < 10) {
        for (let i = 0; i < this.docs1.length; i++) {
          if (this.fileArray.includes(this.docs1[i].name)) {
            this.$emit("show-msg", "Duplicate File");
          } else {
            const urls = URL.createObjectURL(this.docs1[i]);
            this.displayImage.push(urls);
            this.docs.push(this.docs1[i]);
            this.fileArray.push(this.docs1[i].name);
          }
        }
      } else {
        this.$emit("show-msg", "Maximum 10 images can be uploaded");
      }
    },
    itemadd() {
      if (!this.title) {
        this.$emit("show-msg", "Please Provide title.");
        return;
      }
      if (!this.description) {
        this.$emit("show-msg", "Please Provide description.");
        return;
      }
      if (!this.displayImage || this.displayImage.length === 0) {  
        this.$emit("show-msg", "Please add at least one image.");
        return;
      }

      let formData = new FormData();
      formData.append("title", this.title);
      formData.append("description", this.description);

      for (let i = 0; i < this.docs.length; i++) {
        formData.append("photo", this.docs[i]);
      }
      
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/resource/addimage",
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
        data: formData,
      })
      .then((response) => {
        this.appLoading = false;
        if (response.data.status) {
          this.$emit("success", response.data.msg);
          this.clearForm();
        } else {
          this.$emit("show-msg", response.data.msg);
        }
      })
      .catch((err) => {
        this.appLoading = false;
        this.ServerError = true;
        console.log(err);
      });
    },
  },
};
</script>
